import { useState } from 'react';

interface ChildProps {
  handleSeleccionarCampo: (details: "Numero de bultos" | "Numero de Kg") => void
  camposSeleccionados: ("Numero de bultos" | "Numero de Kg")[]
}

const OpcionesCamposGuia : React.FC<ChildProps> = ({ handleSeleccionarCampo, camposSeleccionados }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(!show);
  return (
  <>
    <div className='d-flex justify-content-start mb-2 mt-2'>
        <button onClick={() => handleShow()} className='btn btn-primary '>
          Mostrar opciones
        </button>
    </div>
    {show ?
      <div className='mb-4 mt-1'>
        <div className="form-check mt-1">
          <input
            className="form-check-input"
            type="checkbox"
            checked={camposSeleccionados.includes("Numero de bultos")}
            onChange={() => handleSeleccionarCampo("Numero de bultos")}
          />
          <label className="form-check-label" htmlFor="inlineFormCheck">Número de bultos </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={camposSeleccionados.includes("Numero de Kg")}
            onChange={() => handleSeleccionarCampo("Numero de Kg")}
            />
          <label className="form-check-label" htmlFor="inlineFormCheck">Numero de Kg</label>
        </div>
      </div>
      : <></>}
  </>
  );

}


export default OpcionesCamposGuia